import { database } from '../../firebase';
import { Spinner } from 'react-bootstrap';

import CustomLayout from 'component/layout/custom_layout';
import { useStyles } from './styles';
import { useLazyQuery, useMutation } from '@apollo/client';
import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { intersectionBy, pick, differenceBy, isArray } from 'lodash';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { TRACK_EVENT } from 'utils/analytics';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from 'redux/store';
import { createPortal } from 'react-dom';

import { useSpinnerLoading } from 'hooks/useSpinnerLoading';
import WidgetPopup from 'component/popup/customize_popup';
import { WidgetCode } from 'component/popup/constant';
import ParserIcon from '../../assets/svg/parserIcon.svg';
import utils from 'utils/utils';
import { use100vh } from 'react-div-100vh';
import ModalFull, { ETitleModal } from 'component/modal_full_screen';
import constant, { LOCAL_STORAGE_KEY, SESSION_STORAGE_KEY } from 'utils/constant';
import StyleAction from './styleAction';
import { usePersonalizedLoading } from 'hooks/usePersonalizedLoading';
import {
    getConversation_conversations_data,
    getConversation_conversations_data_messages,
} from '__generated__/getConversation';
import { createConversation_conversation_messages_elements } from '__generated__/createConversation';
import {
    LanguageCode,
    MessageRoleEnum,
    MessageScopeEnum,
    MessageTypeEnum,
    MessageVisibleEnum,
    ProductTypeEnum,
    StyleConversationStatusEnum,
    StyleMessageElementFunctionNameEnum,
    StyleMessageElementTemplateEnum,
    StyleMessageElementTypeEnum,
} from '__generated__/globalTypes';
import { setAuthRedirect } from 'hooks/useAuthRedirection';
import { useQueryParams } from 'hooks/useQueryParams';
import { setSelectedQuestion } from 'redux/widget/widget.slice';
import FloatingDownArrow from 'component/floating_down_arrow';
import ShopNow from './shopNow';
import { WIDGET_CONSTANTS } from 'constants/iframe-events';
import { renderToString } from 'react-dom/server';
import { useHistory } from 'react-router-dom';
import DynamicLabel from './DynamicLabel';
import { AmiraFooter } from './AmiraFooter';
import LoadingDataSpinner from 'component/loading_spinner/loading_data_spinner';
import langUtils, { DEFAULT_SUPPORTING_LANGUAGES, STRING_CONST } from '../language/utils';
import TypeWriterCustom from '../../component/TypeWriterCustom';
import ChatDate from 'component/ChatDate';
import { GET_SUGGESTED_QUESTIONS_BY_IDS } from 'graph_ql/suggested_questions/queries';
import { STRINGS } from '../../constants/strings';
import { GetUserByUserNameOrId, GetUserByUserNameOrIdVariables } from '__generated__/GetUserByUserNameOrId';
import { GET_USER_BY_USERNAME_OR_ID } from 'graph_ql/users/queries.gql';
import HangerWhite from '../../assets/svg/hanger.svg';
import CloseIcon from '../../assets/svg/close.svg';
import { PATH } from 'routes/constant';
import { GET_PENDING_QUIZZES_RESPONSE } from 'graph_ql/getQuiz/queries';
import styles from './styles.module.scss';
import './dynamic_layout.scss';
import { UserQuizStatus } from 'containers/quiz_manager';
import { getDatabase, goOnline, onValue, ref } from 'firebase/database';
import UserType from 'constants/user';
import { TimedSessionStorage } from 'utils/TimedSessionStorage';
import StyleImageSlider from './StyleImageSlider';
import clsx from 'clsx';
import useConfigurationData from 'hooks/useConfigurationData';
import { DynamicLayoutVersion } from 'types/types';
import { useVisualViewport } from '../../utils/useVisaulViewport';
import styleItemUtils from '../../utils/style_item';
import { DESKTOP_AMIRA_MESSAGE_WIDTH, STYLE_CARD_SUBTRACT_HEIGHT } from '../../constants';
import CanvasLayoutStyle from 'containers/style_detail/canvas_layout_style';
import SuggestionsSlider from './suggestions_slider/SuggestionsSlider';
import useUnlockExpProcessing from './hooks/useUnlockExpProcessing';
import useStylePreview from './hooks/useStylePreview';
import useSelectedElement from './hooks/useSelectedElement';
import useConversation from './hooks/useConversation';
import useExpandedMessageTaffiIds from './hooks/useExpandedMessageTaffiIds';
import useReceivedAssistantMessage from './hooks/useReceivedAssistantMessage';
import useDynamicItemDetail from './hooks/useDynamicItemDetail';
import useReadMoreButton from './hooks/useReadMoreButton';
import { ChatProvider, useChatContext, NEW_THREAD } from './hooks/ChatContext';
import useMessageContainerRef from './hooks/useMessageContainerRef';
import useMessages from './hooks/useMessages';
import ChatSidebar from 'component/chat_side_bar';
import StartNewConversationButton from './StartNewConversationButton';
import ChatHeader from './ChatHeader';
import {
    updateCurrentConversationId,
    updateIsDisplayArchivedThread,
    updateIsInitiateNewChat,
    updateConversations,
    updateMessages as updateReduxMessages,
    updateConversationState,
    updateIsLinkClicked,
} from '../../redux/chat/chat.slice';
import CHATBOT_COMMON_CONST from 'common/json/chatbot.json';
import { toast } from 'react-toastify';
import { UPLOAD_BASE_64 } from 'graph_ql/createStyle/mutation';
import EngagingSlider from './engaging_slider/EngagingSlider';
import { ModelImageProvider } from 'component/vton_card/ModelImageContext';

export interface IMessages extends getConversation_conversations_data_messages {
    tempMessage?: boolean;
}
export interface IElements extends createConversation_conversation_messages_elements {
    taffiId?: string;
}
interface IStyleData {
    message: IMessages;
    element: IElements;
}
export interface IConversation extends getConversation_conversations_data {}
export const DESCRIPTION_MAX_WORDS = 10;
export const DISPLAY_FLOATING_BUTTON = 100;
export const ENABLED_SHOW_MORE_STYLES = false;

const MAX_IMAGE_SIZE_IN_BYTES = 7 * 1024 * 1024; // 7MB

const getBase64 = (file: File) => {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve((reader.result as string) || '');
        reader.onerror = (error) => reject(error);
    });
};

export type TconversationState = {
    loading: boolean;
    loadingMessage: string;
};

export type IConversationState = Record<string, TconversationState>;

enum CALLBACK_FUNCTION_NAME {
    SHOW_MORE_STYLE = 'SHOW_MORE_STYLE',
    STYLE = 'STYLE',
    OPTION_BUTTON = 'OPTION_BUTTON',
    ASSISTANT_MESSAGE = 'ASSISTANT_MESSAGE',
    LOADING_MESSAGE = 'LOADING_MESSAGE',
}
enum REAL_TIME_MESSAGE_TYPE {
    STATE = 'state',
    APPEND_MESSAGE = 'append_message',
    LANGUAGE_CHANGED = 'language_changed',
    TITLE_CHANGED = 'title_changed',
}
enum ACCESS_OPTION_TYPE {
    SIGNUP_OR_LOGIN = 'signup_or_login',
    GUEST = 'guest',
}
enum CREATE_PROFILE_POPUP_STATE {
    OPENED = 'opened',
    CLOSED = 'closed',
}
enum CREATE_PROFILE_POPUP_OPENED_FROM {
    yes = 'FEEDBACK_YES',
    no = 'FEEDBACK_NO',
}
export enum FEEDBACK_VALUES {
    YES = 'yes',
    NO = 'no',
}
const CREATE_PROFILE_POPUP_TITLE = {
    yes: STRINGS.GLAD_I_COULD_HELP,
    no: STRINGS.THANKS_FOR_FEEDBACK,
};
export enum CREATE_PROFILE_POPUP_OPENED_ACTION {
    CREATE_PROFILE = 'CREATE_PROFILE',
    ALREADY_HAVE_A_PROFILE = 'ALREADY_HAVE_A_PROFILE',
    CLOSED = 'CLOSED',
    AUTO_SEND = 'AUTO_SEND',
}
const questionsWithMultipleOptions = [
    MessageTypeEnum.feedback,
    MessageTypeEnum.gender_quiz,
    MessageTypeEnum.conversation,
];

export const DEFAULT_CONVERSATION_SIZE = 1;
const DEFAULT_PAGE_NUMBER = 0;
const MESSAGE_TIME_FORMAT = 'hh:mm a';
const OPENING_MESSAGE_ID = 'opening_message';

export enum StyleQuizRedirectionSource {
    COMPLETE_QUIZ_POPUP_BUTTON = 'COMPLETE_QUIZ_POPUP_BUTTON',
    COMPLETE_QUIZ_HANGER_BUTTON = 'COMPLETE_QUIZ_HANGER_BUTTON',
}

export default function ChatContainer() {
    return (
        <ChatProvider>
            <ChatSection />
        </ChatProvider>
    );
}

function ChatSection() {
    const windowSize = useVisualViewport();
    const { stitcher } = useConfigurationData();
    const classes = useStyles();
    const storeId = useSelector((state: RootState) => state.widget.store?.id);
    const storeSupportedLanguages = useSelector(
        (state: RootState) => state.widget.store?.supportedLanguages || DEFAULT_SUPPORTING_LANGUAGES,
    );
    const overBottomBar = document.getElementById('over_bottom_bar') as HTMLElement;
    const {
        messages,
        // setMessages,
        message,
        setMessage,
    } = useMessages();
    const { isReceivedAssistantMessage } = useReceivedAssistantMessage();
    const { conversation } = useConversation();
    const {
        updateFeedbackButton,
        pendingMessages,
        setPendingMessages,
        scrollTopRef,
        getConversationFn,
        messageLoading,
        setConsumer,
        restoredPosition,
        setRestoredPosition,
        getConsumerConversation,
        consumerMessageLoading,
        updateChat,
        sendMessage,
        user,
        isUserAuthenticated,
        updateLocalUser,
        userName,
        localUser,
        handleAnalytics,
        messagesWithPendingMessage,
        setMessagesWithPendingMessage,
        pendingMessageLoading,
        scrollToBottomOnMessageDisplay,
        handleMessageDisplay,
        displayFloatingButton,
        handleScroll,
        getSingleConversationFn,
        resetPageNum,
        isInitiateNewConveration,
        isConversationDone,
        conversationState,
        setIsReceivedAssistantMessage,
        setPendingElements,
        getReduxStoreValue,
        isNewUserFirstMessage,
        updateSourceConversationId,
        isCollectingFeedbackReason,
        setIsCollectingFeedbackReason,
        feedbackMessageRef,
        isEngageSliderPreviewOpen,
        setIsEngageSliderPreviewOpen,
        isEngageSliderPreviewOpenRef,
        isEngagingSliderDisplay,
        listStyles,
        canEngagingSliderDisplay,
        waitingRecommendationMessage,
    } = useChatContext();
    const isStylistView = Boolean(userName);
    const { showStylePreview, setShowStylePreview } = useStylePreview();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { selectedElement, setSelectedElement } = useSelectedElement();
    const { isExpandedMessage } = useExpandedMessageTaffiIds();
    const [callBackFunctionName, setCallBackFunctionName] = useState('');
    const [displayedStyle, setDisplayedStyle] = useState<IStyleData | null>(null);
    const { isUnlockExpProcessing, setIsUnlockExpProcessing, openAuthPopup } = useUnlockExpProcessing();
    const [showCreateProfile, setShowCreateProfile] = useState<boolean>(false);
    const [createProfilePromptTitle, setCreateProfilePromptTitle] = useState<string>('');
    const [isContinueAsGuest, setIsContinueAsGuest] = useState<boolean>(user?.isContinueAsGuest || isUserAuthenticated);
    const initialPendingCallbackData = useMemo(() => {
        return {
            message: {},
            element: {},
            isPending: false,
        };
    }, []);
    const [pendingCallback, setPendingCallback] = useState(initialPendingCallbackData);
    const messageContainerRef = useMessageContainerRef();
    const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
    const isScrollToBottomRef = useRef<boolean>(false);
    const { showDynamicItemDetail, setShowDynamicItemDetail } = useDynamicItemDetail();

    const height: any = use100vh();
    const [isOpen, setIsOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [item, setItem] = useState<string>('');
    const [code, setCode] = useState<ETitleModal>(ETitleModal.FAQ);
    const restoredItemRef = useRef(null);
    const queryParams = useQueryParams();
    const selectedQuestion = useSelector((state: RootState) => state.widget?.selectedQuestion);
    const suggestedQuestionIds = useSelector((state: RootState) => state?.widget?.store?.suggestedQuestionIds);
    const [suggestedQuestions, setSuggestedQuestions] = useState([]);
    const isWidgetOpened = useSelector((state: RootState) => state.widget.isOpened);
    const [focusInput, setFocusInput] = useState<boolean>(false);
    const [isUploadingImage, setIsUploadingImage] = useState<boolean>(false);
    const showAuthPopup = useSelector((state: RootState) => state.global.showAuthPopup);
    const isDisplayArchivedThread = useSelector((state: RootState) => state.chat.isDisplayArchivedThread);
    const archivedThreadDate = useSelector((state: RootState) => state.chat.archivedThreadDate);
    const isInitiateNewChat = useSelector((state: RootState) => state.chat.isInitiateNewChat);
    const currentConversationId = useSelector((state: RootState) => state.chat.currentConversationId);
    const isInitialCallMade = useRef(false);
    const isSendNewMessage = useRef(false);
    const newMessageQuestion = useRef({});
    const isInitialRTCall = useRef(true);
    const isPopupQuestionSent = useRef(false);
    const reduxMessages = useSelector((state: RootState) => state.chat.messages);
    const db = getDatabase();
    const engageSliderRef = useRef<any>(null);

    const [getSuggestedQuestionsByIds, { loading: suggestedQuestionsLoading }] = useLazyQuery(
        GET_SUGGESTED_QUESTIONS_BY_IDS,
        {
            onCompleted(response) {
                setSuggestedQuestions(response?.getSuggestedQuestionsByIds);
            },
        },
    );

    const [uploadImageMutation] = useMutation(UPLOAD_BASE_64, {
        context: {
            allowAnonymousAuth: true,
        },
    });

    const handleImageSelection = useCallback(
        async (file: File) => {
            if (!file.type.startsWith('image/')) {
                toast.error('Please select a valid image file.');
                return;
            }

            if (file.size > MAX_IMAGE_SIZE_IN_BYTES) {
                toast.error('Image size exceeds the 7MB limit. Please choose a smaller file.');
                return;
            }

            setIsUploadingImage(true);
            try {
                const base64 = await getBase64(file);
                const folderPrefix = `public/chat-uploads/${user.id || 'guest'}`;
                const filename = `${conversation?.id || 'conversation'}-${Date.now()}`;
                const response = await uploadImageMutation({
                    variables: {
                        input: {
                            filename,
                            mimetype: file.type,
                            folder: folderPrefix,
                            data: base64,
                            removeBackground: true,
                        },
                    },
                });
                const uploadedImageUrl = response?.data?.uploadFileBase64?.url;

                if (!uploadedImageUrl) {
                    throw new Error('Missing uploaded image URL');
                }
                sendMessage({
                    files: [uploadedImageUrl],
                    userMessage: 'Image uploaded',
                    inAppDynamicMessage: [
                        `({isTempMessage}) => \`<div class='image-message-container \${isTempMessage ? 'loading' : ''}'><img src=${uploadedImageUrl} class='image-message' /><div class='loading-overlay'><div class='spinner'></div><div class='loading-text'>UPLOADING...</div></div></div>\``,
                        'isTempMessage',
                    ],
                });
                dispatch(setSelectedQuestion(null));
            } catch (error) {
                console.error('Image upload failed', error);
                toast.error('Unable to upload the image. Please try again.');
            } finally {
                setIsUploadingImage(false);
            }
        },
        [conversation?.id, dispatch, sendMessage, uploadImageMutation, user.id],
    );

    const isDynamicLayout = (element: any) => {
        return (
            element.imageJson &&
            stitcher.dynamicLayoutVersion === DynamicLayoutVersion.v2 &&
            (element?.stylistId !== process.env.REACT_APP_SHOPIFY_STYLIST_ID ||
                element?.items?.every((item: any) => item?.category && item?.images?.length))
        );
    };

    useEffect(() => {
        try {
            const parsedQuestions = TimedSessionStorage.getItemWithExpiration(
                SESSION_STORAGE_KEY.TAFFI_STORE_SUGGESTED_QUESTIONS,
            );
            if (parsedQuestions) {
                setSuggestedQuestions(parsedQuestions);
            } else {
                getSuggestedQuestionsByIds({
                    variables: {
                        input: {
                            ids: utils.isAppInWidgetMode() && storeId ? suggestedQuestionIds : [],
                        },
                    },
                });
            }
        } catch (error) {
            if (error instanceof SyntaxError) {
                console.error('Invalid JSON:', error);
            } else console.log('Error Occured: ', error);
        }
    }, [storeId, suggestedQuestionIds, getSuggestedQuestionsByIds]);

    const [getUserByUserName, { loading: userLoading }] = useLazyQuery<
        GetUserByUserNameOrId,
        GetUserByUserNameOrIdVariables
    >(GET_USER_BY_USERNAME_OR_ID, {
        onCompleted(data) {
            setConsumer(data.getUserByUserNameOrId as any);
            getConsumerConversation({
                variables: {
                    input: {
                        userId: data.getUserByUserNameOrId?.id as string,
                        paging: {
                            orderBy: constant.ORDER_BY.CREATED_DESC,
                            page: DEFAULT_PAGE_NUMBER,
                            size: DEFAULT_CONVERSATION_SIZE,
                        },
                    },
                },
            });
        },
    });

    const scrollToBottom = useCallback(() => {
        if (scrollTopRef.current <= (messageContainerRef?.current?.scrollTop || 0)) {
            messageContainerRef.current?.scrollTo({
                top: messageContainerRef.current?.scrollHeight,
                behavior: 'smooth',
            });
            scrollTopRef.current = messageContainerRef?.current?.scrollTop || 0;
        }
    }, [messageContainerRef, scrollTopRef]);

    const handleTextChange = (e) => {
        setMessage(e.target.value);
    };

    const scrollToLatestMessage = useCallback(() => {
        messageContainerRef.current?.scrollTo({
            top: messageContainerRef.current?.scrollHeight,
            behavior: 'smooth',
        });
        scrollTopRef.current = messageContainerRef?.current?.scrollTop || 0;
    }, [messageContainerRef, scrollTopRef]);

    useEffect(() => {
        if (messages.length && !isInitialCallMade.current) {
            // Scroll to bottom when coming back to Amira screen from other screen
            setTimeout(() => {
                if (messageContainerRef.current)
                    messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
            }, 0);
        }
    }, [messages.length, messageContainerRef]);

    const getInitialConversation = useCallback(() => {
        if (!conversation && !messages.length) {
            getConversationFn({
                variables: {
                    input: {
                        paging: {
                            orderBy: constant.ORDER_BY.UPDATED_DESC,
                            page: DEFAULT_PAGE_NUMBER,
                            size: DEFAULT_CONVERSATION_SIZE,
                        },
                        lastUpdated: isDisplayArchivedThread ? archivedThreadDate : undefined,
                    },
                },
            });
        } else if (currentConversationId) {
            getSingleConversationFn({
                variables: {
                    input: {
                        id: currentConversationId,
                    },
                },
            });
            updateSourceConversationId(currentConversationId);
        }
    }, [
        conversation,
        messages,
        isDisplayArchivedThread,
        archivedThreadDate,
        getConversationFn,
        currentConversationId,
        getSingleConversationFn,
        updateSourceConversationId,
    ]);

    useEffect(() => {
        if (
            ((utils.isAppInWidgetMode() && isWidgetOpened) || !utils.isAppInWidgetMode()) &&
            !isInitialCallMade.current
        ) {
            if (isStylistView) {
                getUserByUserName({
                    variables: {
                        input: {
                            userName,
                        },
                    },
                });
            } else {
                getInitialConversation();
            }
            isInitialCallMade.current = true;
        }
    }, [getInitialConversation, isStylistView, getUserByUserName, userName, isWidgetOpened]);

    useEffect(() => {
        if (
            utils.isAppInWidgetMode() &&
            selectedQuestion &&
            (isUserAuthenticated || localUser?.gender) &&
            !conversationState?.loading
        ) {
            localStorage.setItem(
                WIDGET_CONSTANTS.STYLE_ASSISTANT_SOURCE_CONVERSATION,
                conversation?.id ? conversation?.id : NEW_THREAD,
            );
            sendMessage({
                trendingQuestion: selectedQuestion,
            });
            dispatch(setSelectedQuestion(null));
        }
    }, [
        selectedQuestion,
        localUser,
        isUserAuthenticated,
        dispatch,
        sendMessage,
        conversationState?.loading,
        conversation,
    ]);

    const handleRealTimeSnapShot = useRef<any>();
    window.onmessage = (event) => {
        if (event.data.name === TRACK_EVENT.WIDGET_OPENED && messageContainerRef?.current) {
            messageContainerRef.current.scrollTop = messageContainerRef?.current?.scrollHeight;
        }
    };

    useEffect(() => {
        const connectedRef = ref(db, '.info/connected');
        onValue(connectedRef, (snap) => {
            if (!snap.val()) {
                // const userInfo = {
                //     userId: user?.id,
                //     userType: user?.userType,
                //     email: user?.email,
                //     gender: user?.gender,
                //     name: user?.firstName,
                // };
                // let isRetried = false;
                if (navigator?.onLine) {
                    goOnline(db);
                    // isRetried = true;
                }
                // trackEvent(TRACK_EVENT.REAL_TIME_DATABASE_CONNECTION, {
                //     ...userInfo,
                //     connection: snap.val(),
                //     networkState: navigator?.onLine,
                //     isRetried,
                // });
            }
        });
    }, [db, user]);

    const getWaitingRecommendationMessage = (existingMessages = [], waitingMessage = []) => {
        let pendingMessages = [];
        if (existingMessages?.length && waitingMessage?.length) {
            pendingMessages = differenceBy(waitingMessage, existingMessages, 'taffiId');
        }
        return pendingMessages ?? [];
    };

    useEffect(() => {
        handleRealTimeSnapShot.current = async (snapshot) => {
            if (isInitialRTCall.current) {
                isInitialRTCall.current = false;
                return;
            }
            const realTimeMessage = snapshot.val();
            const rtmConversationId = realTimeMessage?.data?.id;
            const updatedReduxMessages =
                getReduxStoreValue({
                    reducerName: 'chat',
                    stateName: 'messages',
                    key: rtmConversationId,
                }) ?? [];
            if (
                (rtmConversationId === NEW_THREAD && !currentConversationId && !isDisplayArchivedThread) ||
                rtmConversationId === currentConversationId
            ) {
                if (realTimeMessage?.type === REAL_TIME_MESSAGE_TYPE.STATE) {
                    dispatch(
                        updateConversationState({
                            key: rtmConversationId,
                            value: { loadingMessage: realTimeMessage?.data?.value },
                        }),
                    );
                } else if (realTimeMessage?.type === REAL_TIME_MESSAGE_TYPE.LANGUAGE_CHANGED) {
                    if (conversation) {
                        dispatch(
                            updateConversations({
                                key: conversation.id,
                                value: { ...conversation, language: realTimeMessage?.data?.value },
                            }),
                        );
                    }
                } else if (
                    realTimeMessage?.type === REAL_TIME_MESSAGE_TYPE.APPEND_MESSAGE &&
                    realTimeMessage?.data?.value &&
                    updatedReduxMessages.length &&
                    (canEngagingSliderDisplay
                        ? realTimeMessage?.data?.value[0]?.type !== 'recommendation_message'
                        : true)
                ) {
                    const checkEngageSliderStateAndUpdate = () => {
                        if (isEngageSliderPreviewOpenRef.current) {
                            setTimeout(() => {
                                checkEngageSliderStateAndUpdate();
                            }, 500);
                            return;
                        } else {
                            const updateChatMessage = () => {
                                const existingMessage = intersectionBy(
                                    [...updatedReduxMessages, ...pendingMessages],
                                    realTimeMessage.data?.value,
                                    'taffiId',
                                );
                                if (!existingMessage.length) {
                                    updateChat(
                                        conversation,
                                        [
                                            ...updatedReduxMessages,
                                            ...getWaitingRecommendationMessage(
                                                updatedReduxMessages,
                                                waitingRecommendationMessage.current[rtmConversationId],
                                            ),
                                            ...realTimeMessage.data?.value,
                                        ],
                                        false,
                                    );
                                    waitingRecommendationMessage.current = {
                                        ...waitingRecommendationMessage.current,
                                        rtmConversationId: [],
                                    };
                                }
                            };
                            if (
                                engageSliderRef?.current &&
                                isEngagingSliderDisplay(conversationState?.loadingMessage || '')
                            ) {
                                engageSliderRef?.current.classList.add('fade-out');
                                setTimeout(() => {
                                    updateChatMessage();
                                }, 1000);
                            } else {
                                updateChatMessage();
                            }
                        }
                    };
                    checkEngageSliderStateAndUpdate();
                }
                if (
                    realTimeMessage?.type === REAL_TIME_MESSAGE_TYPE.APPEND_MESSAGE &&
                    realTimeMessage?.data?.value &&
                    updatedReduxMessages.length &&
                    realTimeMessage?.data?.value[0]?.type === 'recommendation_message'
                ) {
                    waitingRecommendationMessage.current = {
                        ...waitingRecommendationMessage.current,
                        [rtmConversationId]: realTimeMessage?.data?.value,
                    };
                }
                if (
                    realTimeMessage?.type !== REAL_TIME_MESSAGE_TYPE.STATE &&
                    isArray(realTimeMessage?.data?.value) &&
                    realTimeMessage?.data?.value[0]?.type !== 'recommendation_message'
                ) {
                    const checkEngageSliderStateAndUpdate = () => {
                        if (isEngageSliderPreviewOpenRef.current) {
                            setTimeout(() => {
                                checkEngageSliderStateAndUpdate();
                            }, 500);
                            return;
                        } else {
                            const updateLoadingState = () => {
                                dispatch(
                                    updateConversationState({
                                        key: rtmConversationId,
                                        value: { loadingMessage: false },
                                    }),
                                );
                            };
                            if (
                                engageSliderRef?.current &&
                                isEngagingSliderDisplay(conversationState?.loadingMessage || '')
                            ) {
                                engageSliderRef?.current.classList.add('fade-out');
                                setTimeout(() => {
                                    updateLoadingState();
                                }, 1000);
                            } else {
                                updateLoadingState();
                            }
                        }
                    };
                    checkEngageSliderStateAndUpdate();
                }
            } else if (rtmConversationId !== currentConversationId) {
                if (
                    realTimeMessage?.type === REAL_TIME_MESSAGE_TYPE.APPEND_MESSAGE &&
                    realTimeMessage?.data?.value &&
                    reduxMessages[rtmConversationId]
                ) {
                    const existingMessage = intersectionBy(
                        reduxMessages[rtmConversationId],
                        realTimeMessage.data?.value,
                        'taffiId',
                    );
                    if (!existingMessage.length) {
                        dispatch(
                            updateReduxMessages({
                                key: rtmConversationId,
                                value: [...reduxMessages[rtmConversationId], ...realTimeMessage.data?.value],
                                extraData: {
                                    from: 'realtime update: other id scenario',
                                },
                            }),
                        );
                    }
                }
            }
        };
    }, [
        user.id,
        conversation,
        messages,
        updateChat,
        handleAnalytics,
        pendingMessages,
        dispatch,
        currentConversationId,
        isDisplayArchivedThread,
        reduxMessages,
        getReduxStoreValue,
        isEngageSliderPreviewOpenRef,
        conversationState?.loadingMessage,
        isEngagingSliderDisplay,
        canEngagingSliderDisplay,
        waitingRecommendationMessage,
    ]);

    useEffect(() => {
        if (isReceivedAssistantMessage) {
            timerRef.current = setInterval(() => {
                scrollToBottom();
            }, 500);
        } else {
            if (timerRef.current) clearInterval(timerRef.current);
        }
    }, [isReceivedAssistantMessage, scrollToBottom]);

    useEffect(() => {
        if (user?.id && handleRealTimeSnapShot.current) {
            const onValueChange = database.realtimeDatabase
                .ref('conversations')
                .child(user?.id)
                .child('event')
                .on('value', (snapshot) => {
                    handleRealTimeSnapShot.current(snapshot);
                });
            return () => {
                database.realtimeDatabase
                    .ref('conversations')
                    .child(user?.id)
                    .child('event')
                    .off('value', onValueChange);
            };
        }
    }, [user?.id, db]);

    const getFormattedTime = (date) => {
        try {
            return format(parseISO(date), MESSAGE_TIME_FORMAT);
        } catch (e) {
            console.error('Error formatting date:', e, date);
            return '';
        }
    };

    const clearChatWindow = useCallback(() => {
        resetPageNum();
        setPendingMessages([]);
        setPendingElements([]);
        setMessagesWithPendingMessage([]);
        setIsReceivedAssistantMessage(false);
        setIsCollectingFeedbackReason(false);
        feedbackMessageRef.current = null;
        dispatch(
            updateIsDisplayArchivedThread({
                value: false,
            }),
        );
        dispatch(
            updateIsInitiateNewChat({
                value: false,
            }),
        );
        dispatch(
            updateCurrentConversationId({
                value: '',
            }),
        );
    }, [
        resetPageNum,
        setPendingMessages,
        setPendingElements,
        setMessagesWithPendingMessage,
        setIsReceivedAssistantMessage,
        setIsCollectingFeedbackReason,
        feedbackMessageRef,
        dispatch,
    ]);

    const handleNewConversation = useCallback(() => {
        if (!isInitiateNewConveration) return;
        clearChatWindow();
        dispatch(
            updateIsInitiateNewChat({
                value: true,
            }),
        );
    }, [isInitiateNewConveration, clearChatWindow, dispatch]);

    useEffect(() => {
        const messageId = queryParams.get('messageTaffiId');

        if (!messages.find((m) => m?.taffiId === messageId) || restoredPosition || !restoredItemRef.current) return;
        setRestoredPosition(true);
        (restoredItemRef as any).current.scrollIntoView();
    }, [restoredPosition, queryParams, messages, setRestoredPosition]);

    const handleSignupClick = useCallback(
        (message) => {
            handleAnalytics(TRACK_EVENT.STYLE_CHAT_ACCESS_OPTION_CLICKED, {
                ...message,
                type: ACCESS_OPTION_TYPE.SIGNUP_OR_LOGIN,
            });
            openAuthPopup();
        },
        [handleAnalytics, openAuthPopup],
    );

    const handleSignupRedirectClick = useCallback(
        (element) => {
            setAuthRedirect(
                element.productType === ProductTypeEnum.item ? element.url : utils.getPathNameFromUrl(element.url),
            );
            openAuthPopup();
        },
        [openAuthPopup],
    );

    const handleStylistConnectClick = useCallback(
        (item, element) => {
            handleAnalytics(TRACK_EVENT.STYLE_CHAT_CONNECT_TO_STYLIST, item, element);
            if (isUserAuthenticated) utils.openUrlInSameTab(element.url);
            else handleSignupRedirectClick(element);
        },
        [handleAnalytics, handleSignupRedirectClick, isUserAuthenticated],
    );

    useEffect(() => {
        if (messagesWithPendingMessage.length) {
            // setMessages(messagesWithPendingMessage);
            dispatch(
                updateReduxMessages({
                    key: conversation?.id,
                    value: messagesWithPendingMessage,
                    extraData: {
                        from: 'useeffect: messagesWithPendingMessage scenario',
                    },
                }),
            );
            setMessagesWithPendingMessage([]);
        }
    }, [
        messagesWithPendingMessage,
        // setMessages,
        setMessagesWithPendingMessage,
        conversation?.id,
        dispatch,
    ]);

    const handleContinueAsGuest = useCallback(
        (message) => {
            if (!isContinueAsGuest) {
                handleAnalytics(TRACK_EVENT.STYLE_CHAT_ACCESS_OPTION_CLICKED, {
                    ...message,
                    type: ACCESS_OPTION_TYPE.GUEST,
                });
                setIsContinueAsGuest(true);
                updateLocalUser({ isContinueAsGuest: true });
                setTimeout(() => {
                    if (messageContainerRef.current) {
                        messageContainerRef.current.scrollTop = messageContainerRef?.current?.scrollHeight;
                    }
                }, 100);
            }
        },
        [messageContainerRef, handleAnalytics, isContinueAsGuest, updateLocalUser],
    );

    const handleLinkClick = useCallback(
        (message, element) => {
            if (element.functionName === StyleMessageElementFunctionNameEnum.signup) {
                if (!isUserAuthenticated) handleSignupClick(message);
            } else if (element.functionName === StyleMessageElementFunctionNameEnum.continue_as_guest) {
                handleContinueAsGuest(message);
            } else if (element.functionName === StyleMessageElementFunctionNameEnum.connect_to_stylist) {
                handleStylistConnectClick(message, element);
            }
        },
        [handleSignupClick, handleContinueAsGuest, handleStylistConnectClick, isUserAuthenticated],
    );

    useEffect(() => {
        if (pendingCallback.isPending && !isReceivedAssistantMessage) {
            setTimeout(() => {
                handleLinkClick(pendingCallback.message, pendingCallback.element);
                setPendingCallback(initialPendingCallbackData);
            }, 1000);
        }
    }, [pendingCallback, initialPendingCallbackData, handleLinkClick, isReceivedAssistantMessage]);

    const lastMessage = useMemo(() => {
        if (messages.length) {
            return messages[messages.length - 1];
        } else {
            return null;
        }
    }, [messages]);

    const handleCallBack = useCallback(
        (name) => {
            switch (name) {
            case CALLBACK_FUNCTION_NAME.LOADING_MESSAGE:
                scrollToBottomOnMessageDisplay();
                break;
            case CALLBACK_FUNCTION_NAME.ASSISTANT_MESSAGE:
                handleMessageDisplay();
                break;
            case CALLBACK_FUNCTION_NAME.OPTION_BUTTON:
                handleMessageDisplay();
                break;
            case CALLBACK_FUNCTION_NAME.SHOW_MORE_STYLE:
                handleMessageDisplay();
                break;
            case CALLBACK_FUNCTION_NAME.STYLE:
                handleMessageDisplay();
                if (displayedStyle?.message && displayedStyle?.element) {
                    handleAnalytics(
                        TRACK_EVENT.STYLE_CHAT_PRODUCT_DISPLAYED,
                        {
                            ...displayedStyle?.message,
                            conversationId: conversation?.id,
                        },
                        displayedStyle?.element,
                    );
                }
                break;
            default:
                break;
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [messageContainerRef, handleMessageDisplay, displayedStyle, conversation?.id, handleAnalytics],
    );

    useEffect(() => {
        if (callBackFunctionName) {
            handleCallBack(callBackFunctionName);
            setCallBackFunctionName('');
        }
    }, [callBackFunctionName, handleCallBack]);
    const handleAnswerOptionClick = useCallback(
        (message, element, reachLastFeedbackRound = false) => {
            if (reachLastFeedbackRound) {
                sendMessage({
                    conversationId: message.conversationId,
                    taffiId: message.taffiId,
                    reachLastFeedbackRound: true,
                });
            } else {
                sendMessage({
                    conversationId: message.conversationId,
                    taffiId: message.taffiId,
                    scope: message.scope,
                    inAppValue: element?.value,
                });
            }
            updateFeedbackButton(message, element);
        },
        [sendMessage, updateFeedbackButton],
    );
    const handleMessageOptionClick = useCallback(
        (message, element) => {
            sendMessage({
                conversationId: message.conversationId,
                taffiId: message.taffiId,
                scope: message.scope,
                inAppValue: element?.value,
                inAppMessage: element?.message,
                inAppDynamicMessage: element?.dynamicLabel,
            });
            updateFeedbackButton(message, element);
        },
        [sendMessage, updateFeedbackButton],
    );

    const storeMessageInstance = useCallback(
        (message, element) => {
            sessionStorage.setItem(LOCAL_STORAGE_KEY.PROCESS_FEEDBACK_CALLBACK, JSON.stringify(true));
            sessionStorage.setItem(LOCAL_STORAGE_KEY.AMIRA_FEEDBACK_MESSAGE, JSON.stringify(message));
            sessionStorage.setItem(LOCAL_STORAGE_KEY.AMIRA_FEEDBACK_ELEMENT, JSON.stringify(element));
            localStorage.setItem(LOCAL_STORAGE_KEY.AMIRA_FEEDBACK_CONVERSATION_ID, conversation?.id as string);
        },
        [conversation?.id],
    );
    const clearMessageInstance = () => {
        sessionStorage.removeItem(LOCAL_STORAGE_KEY.PROCESS_FEEDBACK_CALLBACK);
        sessionStorage.removeItem(LOCAL_STORAGE_KEY.AMIRA_FEEDBACK_MESSAGE);
        sessionStorage.removeItem(LOCAL_STORAGE_KEY.AMIRA_FEEDBACK_ELEMENT);
    };

    const getFeedbackMessage = useCallback(() => {
        return messages[messages.length - 2];
    }, [messages]);

    const processFeedbackCallBack = useCallback(
        (isNavigated, navigationAction) => {
            const isFeedbackProcessStr = sessionStorage.getItem(LOCAL_STORAGE_KEY.PROCESS_FEEDBACK_CALLBACK);
            const isFeedbackProcess = isFeedbackProcessStr ? JSON.parse(isFeedbackProcessStr) : null;
            if (isFeedbackProcess) {
                const amiraMessageStr = sessionStorage.getItem(LOCAL_STORAGE_KEY.AMIRA_FEEDBACK_MESSAGE);
                const amiraMessage = amiraMessageStr ? JSON.parse(amiraMessageStr) : null;
                const amiraElementStr = sessionStorage.getItem(LOCAL_STORAGE_KEY.AMIRA_FEEDBACK_ELEMENT);
                const amiraElement = amiraElementStr ? JSON.parse(amiraElementStr) : null;
                if (amiraMessage && amiraElement && !isNavigated) {
                    if (
                        (isUserAuthenticated && getFeedbackMessage()?.taffiId === amiraMessage?.taffiId) ||
                        !isUserAuthenticated
                    ) {
                        if (amiraElement.value === FEEDBACK_VALUES.YES) {
                            handleAnalytics(TRACK_EVENT.STYLE_CHAT_FEEDBACK_YES_CLICKED, amiraMessage);
                            handleMessageOptionClick(amiraMessage, amiraElement);
                        }
                        clearMessageInstance();
                    } else {
                        clearMessageInstance();
                    }
                }
                handleAnalytics(
                    TRACK_EVENT.STYLE_CHAT_CREATE_PROFILE_POPUP,
                    {
                        ...amiraMessage,
                        conversationId: amiraMessage?.conversationId || conversation?.id,
                        createProfileState: CREATE_PROFILE_POPUP_STATE.CLOSED,
                        createProfileOpenedFrom: CREATE_PROFILE_POPUP_OPENED_FROM[amiraElement.value],
                        createProfileAction: navigationAction,
                    },
                    amiraElement,
                );
            }
        },
        [handleAnalytics, conversation?.id, isUserAuthenticated, getFeedbackMessage, handleMessageOptionClick],
    );

    const closeCreateProfilePrompt = (isNavigated = false, navigationAction = '') => {
        setShowCreateProfile(false);
        processFeedbackCallBack(isNavigated, navigationAction);
    };

    const handleCreateProfilePromptOpen = useCallback(
        (message, element) => {
            const conversationId = message?.conversationId || conversation?.id;
            const popupDisplayedConversationId =
                (localStorage.getItem(LOCAL_STORAGE_KEY.AMIRA_FEEDBACK_CONVERSATION_ID) as string) || '';
            if (!(conversationId === popupDisplayedConversationId && element.value === FEEDBACK_VALUES.NO)) {
                setShowCreateProfile(true);
                setCreateProfilePromptTitle(CREATE_PROFILE_POPUP_TITLE[element.value]);
                storeMessageInstance(message, element);
                handleAnalytics(
                    TRACK_EVENT.STYLE_CHAT_CREATE_PROFILE_POPUP,
                    {
                        ...message,
                        conversationId,
                        createProfileState: CREATE_PROFILE_POPUP_STATE.OPENED,
                        createProfileOpenedFrom: CREATE_PROFILE_POPUP_OPENED_FROM[element.value],
                        createProfileAction: '',
                    },
                    element,
                );
            }
        },
        [handleAnalytics, conversation?.id, storeMessageInstance],
    );

    const handleFeedbackClick = useCallback(
        (element: any, item: any) => {
            if (element.value === FEEDBACK_VALUES.NO) {
                if (element.functionName === StyleMessageElementFunctionNameEnum.simple_feedback) {
                    const feedbackMessages = conversation?.id
                        ? reduxMessages[conversation?.id]?.filter(
                            (m: any) => m.type === MessageTypeEnum.feedback && m.scope === MessageScopeEnum.in_app,
                        ) ?? []
                        : [];
                    handleAnalytics(TRACK_EVENT.STYLE_CHAT_FEEDBACK_NO_CLICKED, item);
                    handleAnswerOptionClick(
                        item,
                        element,
                        feedbackMessages.length >= CHATBOT_COMMON_CONST.MAX_FEEDBACK_MESSAGES_BEFORE_LIMIT,
                    );
                } else {
                    const content = item.elements?.find((e: any) => e.value === 'no')?.label || 'No';
                    const tempMessage: IMessages = {
                        content,
                        elements: [],
                        role: MessageRoleEnum.user,
                        scope: MessageScopeEnum.in_app,
                        visible: MessageVisibleEnum.visible,
                        tempMessage: true,
                        created: new Date().toISOString(),
                    } as unknown as IMessages;
                    dispatch(
                        updateReduxMessages({
                            key: conversation?.id,
                            value: [...messages, tempMessage],
                            extraData: {
                                from: 'click feedback no',
                            },
                        }),
                    );

                    if (conversation?.id) {
                        const feedbackMessages =
                            reduxMessages[conversation?.id]?.filter(
                                (m: any) => m.type === MessageTypeEnum.feedback && m.scope === MessageScopeEnum.in_app,
                            ) ?? [];
                        // compare number of feedback messages with 4 because we want to limit the feedback rounds to 3 (2 in_app feedback messages for each round)
                        if (feedbackMessages.length >= CHATBOT_COMMON_CONST.MAX_FEEDBACK_MESSAGES_BEFORE_LIMIT) {
                            handleAnalytics(TRACK_EVENT.STYLE_CHAT_FEEDBACK_NO_CLICKED, item);
                            sendMessage({
                                conversationId: conversation.id,
                                taffiId: item.taffiId,
                                reachLastFeedbackRound: true,
                            });
                            updateFeedbackButton(element, item);
                            return;
                        }
                    }
                    setFocusInput(true);
                    setTimeout(() => {
                        scrollToLatestMessage();
                    }, 200);
                    setIsCollectingFeedbackReason(true);
                    feedbackMessageRef.current = item;
                }
            } else if (!isUserAuthenticated) {
                handleCreateProfilePromptOpen(item, element);
            } else {
                handleAnalytics(TRACK_EVENT.STYLE_CHAT_FEEDBACK_YES_CLICKED, item);
                handleMessageOptionClick(item, element);
            }
        },
        [
            conversation?.id,
            dispatch,
            feedbackMessageRef,
            handleAnalytics,
            handleCreateProfilePromptOpen,
            handleMessageOptionClick,
            isUserAuthenticated,
            messages,
            reduxMessages,
            scrollToLatestMessage,
            sendMessage,
            setIsCollectingFeedbackReason,
            updateFeedbackButton,
            handleAnswerOptionClick,
        ],
    );

    useEffect(() => {
        if (isUserAuthenticated && messages.length && conversation) {
            if (getFeedbackMessage()?.type === MessageTypeEnum.feedback) {
                processFeedbackCallBack(false, CREATE_PROFILE_POPUP_OPENED_ACTION.AUTO_SEND);
            }
        }
    }, [isUserAuthenticated, messages, conversation, processFeedbackCallBack, getFeedbackMessage]);

    const LoadElements = useCallback(
        (messages, item: getConversation_conversations_data_messages, index) => {
            const messageType = item.type;
            const isQuestionWithMultipleOptions = questionsWithMultipleOptions.includes(item.type);
            const lastMessageIndex = messages.length - 1;
            const messagesExcludePersonalizedStyleExp = messages.filter(
                (m) => m?.type !== MessageTypeEnum.personalized_style_exp,
            );
            const lastMessageExcludePersonalizedStyleExp =
                messagesExcludePersonalizedStyleExp[messagesExcludePersonalizedStyleExp.length - 1];
            const lastMessageIsUnlockPersonalizeStyle =
                lastMessageExcludePersonalizedStyleExp?.content === STRINGS.REQUEST_SIGNUP_LOGIN;
            const isSendMessageAllowed =
                !conversationState?.loading &&
                !item?.answer &&
                item.id === lastMessageExcludePersonalizedStyleExp.id &&
                conversation?.status === StyleConversationStatusEnum.in_conversation;
            if (messageType === MessageTypeEnum.recommendation) {
                return (
                    <div className={classes.messageImageContainer} key={`elementContainer_${index}`}>
                        {item.elements.map((element: any, elementIndex) => {
                            let elementItems: any = element?.items;
                            if (element?.productType === ProductTypeEnum.style) {
                                elementItems = element.items?.map((i: any) => {
                                    return {
                                        ...i,
                                        metadata: {
                                            category: i?.data?.metadata?.category || i?.category,
                                        },
                                    };
                                });
                            }
                            return (
                                <Fragment key={`image_${elementIndex}`}>
                                    {element?.type === StyleMessageElementTypeEnum.show_more_suggestions ? (
                                        <Fragment key={`space_${elementIndex}`}>
                                            <div
                                                className={clsx({
                                                    [classes.multiOptionLabel]: true,
                                                })}
                                                onClick={() => {
                                                    if (isStylistView || isDisplayArchivedThread) return;
                                                    if (isSendMessageAllowed) {
                                                        sendMessage({
                                                            conversationId: item.conversationId,
                                                            taffiId: item.taffiId as any,
                                                            scope: item.scope,
                                                            inAppValue: element?.value as any,
                                                            inAppMessage: '',
                                                        });
                                                        updateFeedbackButton(item, element);
                                                        if (
                                                            element?.type ===
                                                            StyleMessageElementTypeEnum.show_more_suggestions
                                                        ) {
                                                            handleAnalytics(
                                                                TRACK_EVENT.STYLE_CHAT_SHOW_MORE_STYLES_CLICKED,
                                                                {
                                                                    conversationId: conversation?.id,
                                                                },
                                                            );
                                                        }
                                                    }
                                                }}
                                                style={{
                                                    display:
                                                        !lastMessageExcludePersonalizedStyleExp?.elements?.find(
                                                            (e) =>
                                                                e?.type ===
                                                                StyleMessageElementTypeEnum.show_more_suggestions,
                                                        ) || item?.answer === element?.value
                                                            ? 'none'
                                                            : 'flex',
                                                    cursor:
                                                        isStylistView || isDisplayArchivedThread
                                                            ? 'not-allowed'
                                                            : 'pointer',
                                                    width:
                                                        windowSize.viewport.width >= 1024
                                                            ? DESKTOP_AMIRA_MESSAGE_WIDTH
                                                            : '80%',
                                                    marginBottom: 8,
                                                    ...langUtils.getLanguageStyle(item?.language),
                                                }}
                                            >
                                                {index === lastMessageIndex && isReceivedAssistantMessage ? (
                                                    <TypeWriterCustom
                                                        name={CALLBACK_FUNCTION_NAME.SHOW_MORE_STYLE}
                                                        content={element?.label?.toUpperCase() as string}
                                                        callBack={setCallBackFunctionName}
                                                        language={item?.language}
                                                    />
                                                ) : (
                                                    element?.label?.toUpperCase()
                                                )}
                                            </div>
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <div
                                                className={`${classes.messageContent}
                                                    ${classes.defaultMessageSize}
                                                    ${classes.messageTextAssistant}
                                                    ${classes.messageContainer}
                                                    ${classes.messageContainerAssistant}`}
                                                style={{
                                                    width: '160px',
                                                    display: 'none',
                                                    ...langUtils.getLanguageStyle(item?.language),
                                                }}
                                            >
                                                {index === lastMessageIndex && isReceivedAssistantMessage ? (
                                                    <TypeWriterCustom
                                                        name={CALLBACK_FUNCTION_NAME.STYLE}
                                                        content=""
                                                        callBack={setCallBackFunctionName}
                                                        extraData={{
                                                            message: item,
                                                            element,
                                                        }}
                                                        setExtraData={setDisplayedStyle}
                                                        language={item?.language}
                                                    />
                                                ) : (
                                                    element?.label
                                                )}
                                            </div>
                                            <div
                                                className={classes.headerContainer}
                                                style={{ marginTop: '4px' }}
                                                ref={
                                                    item.taffiId === queryParams.get('messageTaffiId') &&
                                                    element?.productTaffiId === queryParams.get('productTaffiId')
                                                        ? restoredItemRef
                                                        : null
                                                }
                                            >
                                                <div
                                                    className={clsx({
                                                        [classes.messageContentImage]: true,
                                                        'amira-style-card': true,
                                                    })}
                                                >
                                                    {element?.productTaffiId &&
                                                    element?.productType === ProductTypeEnum.style &&
                                                    isDynamicLayout(element) ? (
                                                            <CanvasLayoutStyle
                                                                style={element}
                                                                items={elementItems ?? []}
                                                                setShowDynamicItemDetail={setShowDynamicItemDetail}
                                                            />
                                                        ) : (
                                                            <img
                                                                src={element?.value!!}
                                                                alt="style"
                                                                className={classes.styleImage}
                                                                style={{
                                                                    height: 'auto',
                                                                    maxHeight:
                                                                    windowSize.viewport.width >= 1024
                                                                        ? 630
                                                                        : windowSize.viewport.height -
                                                                          STYLE_CARD_SUBTRACT_HEIGHT,
                                                                }}
                                                                onClick={() => {
                                                                    setShowStylePreview(true);
                                                                    setSelectedElement(element!!);
                                                                    handleAnalytics(
                                                                        TRACK_EVENT.STYLE_CHAT_PRODUCT_IMAGE_CLICKED,
                                                                        item,
                                                                        element,
                                                                    );
                                                                }}
                                                            />
                                                        )}
                                                    <ShopNow
                                                        element={element!!}
                                                        item={item}
                                                        index={index}
                                                        elementIndex={elementIndex}
                                                        handleAnalytics={handleAnalytics}
                                                        lastMessageIndex={messages.length - 1}
                                                        lastElementIndex={item.elements.length - 1}
                                                    />
                                                    {isStylistView ? null : (
                                                        <StyleAction
                                                            message={item}
                                                            element={{
                                                                ...element!!,
                                                                collectionName:
                                                                    element?.collectionName ||
                                                                    constant.COLLECTION_NAME.STYLES,
                                                            }}
                                                            key={element?.productId}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </Fragment>
                                    )}
                                </Fragment>
                            );
                        })}
                    </div>
                );
            } else {
                return (
                    <div
                        className={classes.optionsContainer}
                        key={`elementContainer_${index}`}
                        style={{
                            flexDirection: isQuestionWithMultipleOptions ? 'row' : 'column',
                        }}
                    >
                        {item?.elements?.map((element, elementIndex) => {
                            if (
                                element?.type === StyleMessageElementTypeEnum.option_message &&
                                !isUserAuthenticated &&
                                isSendMessageAllowed &&
                                element?.functionName === StyleMessageElementFunctionNameEnum.continue_as_guest &&
                                selectedQuestion &&
                                !isPopupQuestionSent.current &&
                                currentConversationId
                            ) {
                                sendMessage({
                                    conversationId: item.conversationId,
                                    taffiId: item.taffiId as any,
                                    scope: item.scope,
                                    inAppValue: element?.value as any,
                                    inAppMessage: element?.message as any,
                                });
                                updateFeedbackButton(item, element);
                                handleLinkClick(item, element);
                                isPopupQuestionSent.current = true;
                            }
                            return (
                                <Fragment key={`space_${elementIndex}`}>
                                    <div
                                        className={`${
                                            element?.template === StyleMessageElementTemplateEnum.message
                                                ? classes.elementTemplateMessage
                                                : isQuestionWithMultipleOptions
                                                    ? classes.multiOptionLabel
                                                    : classes.optionLabel
                                        }`}
                                        onClick={() => {
                                            if (isStylistView || isDisplayArchivedThread || isCollectingFeedbackReason)
                                                return;
                                            if (element?.type === StyleMessageElementTypeEnum.option_message) {
                                                if (
                                                    isSendMessageAllowed ||
                                                    (lastMessageIsUnlockPersonalizeStyle &&
                                                        element?.functionName ===
                                                            StyleMessageElementFunctionNameEnum.continue_as_guest)
                                                ) {
                                                    if (item.type === MessageTypeEnum.feedback) {
                                                        handleFeedbackClick(element, item);
                                                    } else {
                                                        if (
                                                            element?.functionName ===
                                                            StyleMessageElementFunctionNameEnum.other_option
                                                        ) {
                                                            setFocusInput(true);
                                                            handleAnalytics(
                                                                TRACK_EVENT.STYLE_CHAT_OTHER_OPTION_CLICKED,
                                                                item,
                                                            );
                                                        } else {
                                                            handleMessageOptionClick(item, element);
                                                            if (
                                                                item.type === MessageTypeEnum.gender_quiz &&
                                                                !isUserAuthenticated
                                                            ) {
                                                                updateLocalUser({ gender: element?.value });
                                                            }
                                                            if (
                                                                element?.functionName ===
                                                                StyleMessageElementFunctionNameEnum.continue_as_guest
                                                            ) {
                                                                handleLinkClick(item, element);
                                                            }
                                                            setFocusInput(false);
                                                        }
                                                    }
                                                }
                                            } else if (element?.type === StyleMessageElementTypeEnum.link_option) {
                                                if (isSendMessageAllowed) {
                                                    if (
                                                        element?.functionName ===
                                                        StyleMessageElementFunctionNameEnum.signup
                                                    ) {
                                                        if (isUserAuthenticated) {
                                                            return;
                                                        } else {
                                                            setIsUnlockExpProcessing(true);
                                                        }
                                                    }
                                                    setPendingCallback({
                                                        message: item,
                                                        element: element as any,
                                                        isPending: true,
                                                    });
                                                    sendMessage({
                                                        conversationId: item.conversationId,
                                                        taffiId: item.taffiId as any,
                                                        scope: item.scope,
                                                        inAppValue: element?.value as any,
                                                        inAppMessage:
                                                            messages[messages.length - 1].id === item.id
                                                                ? (element?.message as any)
                                                                : null,
                                                        inAppDynamicMessage:
                                                            messages[messages.length - 1].id === item.id
                                                                ? (element?.dynamicLabel as any)
                                                                : null,
                                                    });
                                                    updateFeedbackButton(item, element);
                                                } else {
                                                    handleLinkClick(item, element);
                                                }
                                            } else {
                                                handleLinkClick(item, element);
                                            }
                                        }}
                                        style={{
                                            background:
                                                !isQuestionWithMultipleOptions ||
                                                element?.template === StyleMessageElementTemplateEnum.message
                                                    ? '#ffffff'
                                                    : item?.answer === element?.value
                                                        ? '#F2D4BD'
                                                        : '#FBF4EE',
                                            cursor: isStylistView ? 'not-allowed' : 'pointer',
                                            ...langUtils.getLanguageStyle(item?.language),
                                        }}
                                    >
                                        {index === lastMessageIndex && isReceivedAssistantMessage && item?.language ? (
                                            <TypeWriterCustom
                                                name={CALLBACK_FUNCTION_NAME.OPTION_BUTTON}
                                                content={element?.label as string}
                                                callBack={setCallBackFunctionName}
                                                language={item?.language}
                                            />
                                        ) : element?.dynamicLabel ? (
                                            <DynamicLabel
                                                {...pick(
                                                    {
                                                        dynamicLabel: element?.dynamicLabel[0],
                                                        isLastMessage: index === lastMessageIndex,
                                                        supportedLanguages: storeSupportedLanguages,
                                                    },
                                                    ['dynamicLabel', ...element?.dynamicLabel[1].split(',')],
                                                )}
                                            ></DynamicLabel>
                                        ) : (
                                            element?.label
                                        )}
                                        {element?.template === StyleMessageElementTemplateEnum.message && (
                                            <img src={ParserIcon} alt="arrow" height={16} width={16} />
                                        )}
                                    </div>
                                </Fragment>
                            );
                        })}
                    </div>
                );
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            conversationState?.loading,
            conversation?.status,
            conversation?.id,
            classes.messageImageContainer,
            classes.multiOptionLabel,
            classes.messageContent,
            classes.defaultMessageSize,
            classes.messageTextAssistant,
            classes.messageContainer,
            classes.messageContainerAssistant,
            classes.headerContainer,
            classes.messageContentImage,
            classes.styleImage,
            classes.optionsContainer,
            classes.elementTemplateMessage,
            classes.optionLabel,
            isStylistView,
            isReceivedAssistantMessage,
            queryParams,
            openAuthPopup,
            handleAnalytics,
            isExpandedMessage,
            userName,
            sendMessage,
            updateFeedbackButton,
            isUserAuthenticated,
            selectedQuestion,
            storeSupportedLanguages,
            handleLinkClick,
            updateLocalUser,
            handleMessageOptionClick,
            handleCreateProfilePromptOpen,
            stitcher.dynamicLayoutVersion,
            windowSize.viewport.height,
            windowSize.viewport.width,
        ],
    );

    const handleClickOpen = (name: string, code: ETitleModal) => {
        setOpen(true);
        setItem(name);
        setCode(code);
    };

    const handleClose = () => {
        setOpen(false);
        setIsOpen(true);
    };
    const { readMoreButton, handleShowMore } = useReadMoreButton();

    const isSuggestionMessageDisplay = useCallback(() => {
        const isAuthUserOpeningConversation =
            isUserAuthenticated && conversation?.id === `_opening_conversation_${user?.id}`;
        const messagesExcludePersonalizedStyleExp = messages.filter(
            (m) => m?.type !== MessageTypeEnum.personalized_style_exp,
        );
        return (
            (!messages.length && isInitiateNewChat) || //for every new conversation
            (isAuthUserOpeningConversation && isInitiateNewChat && messagesExcludePersonalizedStyleExp.length === 1) || //for 1st time auth user
            (conversation?.status === StyleConversationStatusEnum.in_conversation && // for unauth user
                lastMessage &&
                lastMessage.type === MessageTypeEnum.gender_quiz &&
                lastMessage.role === MessageRoleEnum.user &&
                !isReceivedAssistantMessage &&
                !conversationState?.loading &&
                !isDisplayArchivedThread &&
                !isStylistView)
        );
    }, [
        messages,
        isInitiateNewChat,
        conversation?.status,
        lastMessage,
        isReceivedAssistantMessage,
        conversationState?.loading,
        isStylistView,
        conversation?.id,
        user?.id,
        isUserAuthenticated,
        isDisplayArchivedThread,
    ]);

    useEffect(() => {
        if (isSuggestionMessageDisplay() && !isScrollToBottomRef.current) {
            scrollToBottom();
            isScrollToBottomRef.current = true;
        } else if (!isSuggestionMessageDisplay() && isScrollToBottomRef.current) {
            isScrollToBottomRef.current = false;
        }
    }, [isSuggestionMessageDisplay, scrollToBottom]);

    const dynamicContentString = useCallback(
        (messages, message, index) =>
            renderToString(
                <DynamicLabel
                    {...pick(
                        {
                            dynamicLabel: message?.dynamicContent[0],
                            className: `${classes.messageContent} ${classes.defaultMessageSize} ${classes.messageTextAssistant}`,
                            isLastMessage: index === messages.length - 1 && !isSuggestionMessageDisplay(),
                            supportedLanguages: storeSupportedLanguages,
                        },
                        ['dynamicLabel', 'className', ...message?.dynamicContent[1].split(',')],
                    )}
                />,
            ),
        [classes, isSuggestionMessageDisplay, storeSupportedLanguages],
    );

    const getMessageContent = useCallback(
        (messages, message, index) => {
            if (message?.type === MessageTypeEnum.recommendation) {
                const descriptionWithoutTitle = message.content.replace(/[^:]+(: )/, '');
                if (isExpandedMessage(message)) {
                    return descriptionWithoutTitle;
                }
                const shortMessage =
                    descriptionWithoutTitle?.split(/\s+/)?.length > DESCRIPTION_MAX_WORDS
                        ? `${descriptionWithoutTitle
                            .split(/\s+/)
                            .slice(0, DESCRIPTION_MAX_WORDS)
                            .join(' ')}${readMoreButton(message)}`
                        : descriptionWithoutTitle;
                return shortMessage;
            } else if (!message.language && message?.dynamicContent?.length > 1) {
                return dynamicContentString(messages, message, index);
            }
            return message.content;
        },
        [isExpandedMessage, readMoreButton, dynamicContentString],
    );

    const AssistantMessage = useCallback(
        (messages, item, index) => {
            const isNextFromAssistant = messages[index + 1]?.role === item.role;
            const elements = item.elements;
            const lastMessageIndex = messages.length - 1;
            const isPersonalizedExpMsg = item?.type === MessageTypeEnum.personalized_style_exp;
            const assistantMessageContainerStyle = isPersonalizedExpMsg
                ? classes.personalMessageContainerAssistant
                : `${classes.messageContainer} ${classes.messageContainerAssistant}`;
            const content = getMessageContent(messages, item, index);
            let shouldDisplayFullWidth = false;
            const shouldUseTypeWriter =
                (index === lastMessageIndex &&
                    isReceivedAssistantMessage &&
                    !isExpandedMessage(item) &&
                    item?.language) ||
                (index === lastMessageIndex && item?.i18n === 'RECOMMEND_OUTFITS' && pendingMessages.length);

            if (
                item?.type === MessageTypeEnum.recommendation &&
                item?.elements?.length &&
                item?.elements[0]?.type === StyleMessageElementTypeEnum.image &&
                isDynamicLayout(item?.elements[0])
            ) {
                const styleCardItems = item?.elements[0]?.items?.map((i: any) => {
                    return {
                        ...i,
                        metadata: {
                            category: i?.data?.metadata?.category || i?.category,
                        },
                    };
                });
                const styleCardColumns = styleItemUtils.mapDynamicLayoutColumn(styleCardItems);
                shouldDisplayFullWidth =
                    styleCardColumns.length === 3 && windowSize && windowSize.viewport.width < 1024;
            }
            return (
                <Fragment key={item?.taffiId || item?.content}>
                    <div
                        className={assistantMessageContainerStyle}
                        style={{
                            marginBottom: isNextFromAssistant || elements?.length ? '4px' : '8px',
                            pointerEvents: isStylistView && isPersonalizedExpMsg ? 'none' : 'auto',
                            display: content?.length ? 'flex' : 'none',
                            width: shouldDisplayFullWidth ? '100%' : '80%',
                        }}
                        onClick={() => handleShowMore(item)}
                    >
                        {shouldUseTypeWriter ? (
                            <div
                                className={`
                                ${classes.messageContent}
                                ${classes.messageTextAssistant}
                                ${isPersonalizedExpMsg ? classes.personalizeMessageSize : classes.defaultMessageSize}
                            `}
                                style={{
                                    ...langUtils.getLanguageStyle(item?.language),
                                }}
                            >
                                <TypeWriterCustom
                                    name={CALLBACK_FUNCTION_NAME.ASSISTANT_MESSAGE}
                                    content={content}
                                    callBack={setCallBackFunctionName}
                                    language={item?.language}
                                />
                            </div>
                        ) : !item.language && item?.dynamicContent?.length > 1 ? (
                            <DynamicLabel
                                {...pick(
                                    {
                                        dynamicLabel: item?.dynamicContent[0],
                                        className: `${classes.messageContent} ${classes.messageTextAssistant} ${
                                            isPersonalizedExpMsg
                                                ? classes.personalizeMessageSize
                                                : classes.defaultMessageSize
                                        }`,
                                        isLastMessage: index === messages.length - 1 && !isSuggestionMessageDisplay(),
                                        supportedLanguages: storeSupportedLanguages,
                                    },
                                    ['dynamicLabel', 'className', ...item?.dynamicContent[1].split(',')],
                                )}
                            ></DynamicLabel>
                        ) : (
                            <div
                                className={`
                                    ${classes.messageContent}
                                    ${classes.messageTextAssistant}
                                    ${
                            isPersonalizedExpMsg
                                ? classes.personalizeMessageSize
                                : classes.defaultMessageSize
                            }
                                `}
                                style={{
                                    ...langUtils.getLanguageStyle(item?.language),
                                }}
                                onClick={() => {
                                    dispatch(updateIsLinkClicked(true));
                                }}
                                dangerouslySetInnerHTML={{ __html: content }}
                            ></div>
                        )}
                        {!isPersonalizedExpMsg && (
                            <div className={`${classes.messageTime} ${classes.messageTextAssistant}`}>
                                {getFormattedTime(item?.created)}
                            </div>
                        )}
                    </div>
                    {elements?.length ? LoadElements(messages, item, index) : null}
                </Fragment>
            );
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            LoadElements,
            classes,
            isReceivedAssistantMessage,
            getMessageContent,
            isExpandedMessage,
            handleShowMore,
            isStylistView,
            isSuggestionMessageDisplay,
            storeSupportedLanguages,
            windowSize,
        ],
    );

    const UserMessage = useCallback(
        (item, index) => {
            return (
                <div key={index} className={`${classes.messageContainer} ${classes.messageContainerUser}`}>
                    {item?.dynamicContent?.length === 2 ? (
                        <DynamicLabel
                            {...pick(
                                {
                                    dynamicLabel: item?.dynamicContent[0],
                                    className: `${classes.messageContent} ${classes.defaultMessageSize} ${classes.messageTextUser}`,
                                    isLastMessage: index === messages.length - 1 && !isSuggestionMessageDisplay(),
                                    supportedLanguages: storeSupportedLanguages,
                                    isTempMessage: index === messages.length - 1 && conversationState?.loading,
                                },
                                ['dynamicLabel', 'className', ...item?.dynamicContent[1].split(',')],
                            )}
                        ></DynamicLabel>
                    ) : (
                        <div
                            className={`${classes.messageContent}
                        ${classes.defaultMessageSize}
                        ${classes.messageTextUser}`}
                            dangerouslySetInnerHTML={{ __html: item.content }}
                        />
                    )}
                    <div className={`${classes.messageTime} ${classes.messageTextUser}`}>
                        {getFormattedTime(item?.created)}
                    </div>
                </div>
            );
        },
        [classes, messages.length, isSuggestionMessageDisplay, storeSupportedLanguages, conversationState?.loading],
    );
    const Loader = useCallback(
        (props) => {
            const { loading = false, className = 'messageLoadingContainer' } = props;
            return loading ? (
                <div className={`${classes[className]}`}>
                    <Spinner animation="grow" className={classes.loaderIcon} />
                    <Spinner animation="grow" className={classes.loaderIcon} />
                    <Spinner animation="grow" className={classes.loaderIcon} />
                </div>
            ) : null;
        },
        [classes],
    );

    const setEngageSliderState = useCallback(
        (value: boolean) => {
            setIsEngageSliderPreviewOpen(value);
        },
        [setIsEngageSliderPreviewOpen],
    );

    const tempAssistantMessage = useCallback(
        (message) => {
            if (isEngagingSliderDisplay(message)) {
                return (
                    <EngagingSlider
                        products={listStyles}
                        isEngageSliderPreviewOpen={isEngageSliderPreviewOpen}
                        setEngageSliderState={setEngageSliderState}
                        conversationId={conversation?.id}
                        ref={engageSliderRef}
                    />
                );
            }
            return (
                <Fragment key={message}>
                    <div
                        className={`${classes.messageContainer} ${classes.messageContainerAssistant}`}
                        style={{ marginBottom: '8px' }}
                    >
                        <div
                            className={`${classes.messageContent}
                                ${classes.defaultMessageSize}
                                ${classes.messageTextAssistant}`}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                ...langUtils.getLanguageStyle(conversation?.language),
                            }}
                        >
                            <TypeWriterCustom
                                name={CALLBACK_FUNCTION_NAME.LOADING_MESSAGE}
                                content={message}
                                callBack={setCallBackFunctionName}
                                language={conversation?.language}
                            />
                            <Loader loading={true} className="messageLoadCon" />
                        </div>
                    </div>
                </Fragment>
            );
        },
        [
            classes,
            Loader,
            conversation?.language,
            listStyles,
            setEngageSliderState,
            isEngageSliderPreviewOpen,
            conversation?.id,
            isEngagingSliderDisplay,
        ],
    );

    useEffect(() => {
        if (isEngagingSliderDisplay(conversationState?.loadingMessage) && engageSliderRef.current) {
            const el = engageSliderRef.current;

            const handleAnimationEnd = (e) => {
                // only handle fadeSlideIn, ignore fadeOutToTop
                if (e.animationName === 'fadeSlideIn') {
                    scrollToBottom();
                }
            };

            el.addEventListener('animationend', handleAnimationEnd, { once: true });

            return () => {
                el.removeEventListener('animationend', handleAnimationEnd);
            };
        }
    }, [conversationState, isEngagingSliderDisplay, scrollToBottom]);

    const LoaderText = useCallback(() => {
        return conversationState?.loadingMessage && !isReceivedAssistantMessage
            ? tempAssistantMessage(conversationState?.loadingMessage)
            : null;
    }, [conversationState?.loadingMessage, tempAssistantMessage, isReceivedAssistantMessage]);

    const getJoinedMessage = (contents, lang) => {
        const joinedMessages = contents.map((content) => {
            return langUtils.getLanguageStr(content, lang);
        });
        return joinedMessages.join(' ');
    };

    const getTrendingQuestionCaption = useCallback((content, languages) => {
        const trendingQuestionCaptions = languages.map((lang) => {
            return langUtils.getLanguageElement(getJoinedMessage([...content], lang), lang);
        });
        return trendingQuestionCaptions.join('\n');
    }, []);

    const getWelcomeMessage = useCallback(() => {
        let welcomeBackMessage = '';
        if (conversation?.language) {
            welcomeBackMessage = getTrendingQuestionCaption(
                [STRING_CONST.WELCOME_BACK_MESSAGE],
                [conversation?.language],
            );
        } else {
            welcomeBackMessage = getTrendingQuestionCaption(
                [STRING_CONST.WELCOME_BACK_MESSAGE],
                storeSupportedLanguages,
            );
        }

        return welcomeBackMessage;
    }, [conversation?.language, getTrendingQuestionCaption, storeSupportedLanguages]);

    const getTrendingQuestions = useCallback(() => {
        let messageSuggestions: {
            content: string;
            language: string;
        }[][] = [];

        const getStoreSuggestedQuestions = (question, language) => {
            const result: {
                content: string;
                language: string;
            }[] = [];
            if (language?.includes(LanguageCode.english)) {
                result.push({
                    content: question?.value,
                    language: LanguageCode.english,
                });
            }
            question?.translatedValues?.forEach((tValue) => {
                if (language.includes(tValue?.language)) {
                    result.push({
                        content: tValue?.value,
                        language: tValue?.language,
                    });
                }
            }, []);
            return result;
        };
        if (conversation?.language) {
            messageSuggestions = suggestedQuestions?.map((q) => {
                return getStoreSuggestedQuestions(q, [conversation?.language]);
            });
        } else {
            messageSuggestions = suggestedQuestions?.map((q) => {
                return getStoreSuggestedQuestions(q, storeSupportedLanguages);
            });
        }

        return messageSuggestions;
    }, [conversation?.language, storeSupportedLanguages, suggestedQuestions]);

    const getTrendingQuestionMessage = useCallback(() => {
        let trendingQuestionMessage = '';
        if (conversation?.language) {
            trendingQuestionMessage = getTrendingQuestionCaption(
                [STRING_CONST.TRENDING_QUESTION_MESSAGE],
                [conversation?.language],
            );
        } else {
            trendingQuestionMessage = getTrendingQuestionCaption(
                [STRING_CONST.TRENDING_QUESTION_MESSAGE],
                storeSupportedLanguages,
            );
        }
        return trendingQuestionMessage;
    }, [conversation?.language, getTrendingQuestionCaption, storeSupportedLanguages]);

    const getOpeningConversationMessage = useCallback(() => {
        let trendingQuestionMessage = '';
        if (conversation?.language) {
            trendingQuestionMessage = getTrendingQuestionCaption(
                [STRING_CONST.LETS_GET_STARTED, STRING_CONST.TRENDING_QUESTION_MESSAGE_OPENING_CONVERSATION],
                [conversation?.language],
            );
        } else {
            trendingQuestionMessage = getTrendingQuestionCaption(
                [STRING_CONST.LETS_GET_STARTED, STRING_CONST.TRENDING_QUESTION_MESSAGE_OPENING_CONVERSATION],
                storeSupportedLanguages,
            );
        }
        return trendingQuestionMessage;
    }, [conversation?.language, getTrendingQuestionCaption, storeSupportedLanguages]);

    const isStartNewConversationButtonDisplay = useMemo(
        () => ((isConversationDone && !isSuggestionMessageDisplay()) || isDisplayArchivedThread) && !isStylistView,
        [isConversationDone, isSuggestionMessageDisplay, isDisplayArchivedThread, isStylistView],
    );

    useEffect(() => {
        if (!currentConversationId && isSendNewMessage.current) {
            sendMessage({
                ...newMessageQuestion.current,
            });
            newMessageQuestion.current = {};
            isSendNewMessage.current = false;
        }
    }, [currentConversationId, sendMessage]);

    const chatMessageSuggestions = useCallback(
        ({ isOpeningConversation = false }) => {
            const trendingQuestions = getTrendingQuestions();
            return (
                <Fragment>
                    <div className={`${classes.messageContainer} ${classes.messageContainerAssistant}`}>
                        <div
                            className={`${classes.messageContent} ${classes.messageTextAssistant} ${classes.defaultMessageSize}`}
                            style={{ marginBottom: '8px' }}
                            dangerouslySetInnerHTML={{
                                __html: isOpeningConversation ? getOpeningConversationMessage() : getWelcomeMessage(),
                            }}
                        />
                    </div>
                    <div
                        className={`${classes.messageContainer} ${classes.messageContainerAssistant}`}
                        style={{ marginTop: '8px', display: isOpeningConversation ? 'none' : 'block' }}
                    >
                        <div
                            className={`${classes.messageContent} ${classes.messageTextAssistant} ${classes.defaultMessageSize}`}
                            style={{ marginBottom: '8px' }}
                            dangerouslySetInnerHTML={{ __html: getTrendingQuestionMessage() }}
                        />
                    </div>
                    {trendingQuestions?.map((item) => {
                        return item?.map((question, index) => {
                            return (
                                <div
                                    onClick={() => {
                                        if (isNewUserFirstMessage()) {
                                            dispatch(
                                                updateCurrentConversationId({
                                                    value: '',
                                                }),
                                            );
                                            isSendNewMessage.current = true;
                                            newMessageQuestion.current = {
                                                trendingQuestion: question.content,
                                                trendingQuestionLanguage: question.language as LanguageCode,
                                            };
                                        } else {
                                            sendMessage({
                                                trendingQuestion: question.content,
                                                trendingQuestionLanguage: question.language as LanguageCode,
                                                isIncludeRequestParameter: true,
                                            });
                                        }
                                    }}
                                    style={{
                                        marginBottom: index === trendingQuestions.length - 1 ? '8px' : '0px',
                                    }}
                                    className={classes.buttonContainer}
                                    key={index}
                                >
                                    <div
                                        className={classes.buttonContent}
                                        style={{ ...langUtils.getLanguageStyle(question?.language) }}
                                    >
                                        {question.content}
                                    </div>
                                    <img src={ParserIcon} alt="arrow" height={16} width={16} />
                                </div>
                            );
                        });
                    })}
                </Fragment>
            );
        },
        [
            classes,
            sendMessage,
            getTrendingQuestions,
            getOpeningConversationMessage,
            getWelcomeMessage,
            getTrendingQuestionMessage,
            dispatch,
            isNewUserFirstMessage,
        ],
    );

    const Messages = useCallback(() => {
        const isOpeningConversation = isUserAuthenticated
            ? conversation?.id === `_opening_conversation_${user?.id}`
            : conversation?.id?.includes('opening') &&
              conversation?.status === StyleConversationStatusEnum.in_conversation;

        const renderRecommendationMessage = (item: IMessages, index: number) => {
            if (ENABLED_SHOW_MORE_STYLES) {
                return AssistantMessage(messages, item, index);
            }
            if (item.type === MessageTypeEnum.recommendation) {
                // only render the recommendation message if it has elements
                if (!item.elements?.length) {
                    return null;
                }
                // if the previous message is a recommendation message, do not display the current recommendation message
                if (messages[index - 1]?.type === MessageTypeEnum.recommendation) {
                    return null;
                }
                const recommendationMessagesToDisplay = [item];
                let nextIndex = index + 1;
                while (
                    messages[nextIndex]?.type === MessageTypeEnum.recommendation &&
                    messages[nextIndex]?.elements?.length
                ) {
                    recommendationMessagesToDisplay.push(messages[nextIndex]);
                    nextIndex++;
                }
                // check if conversation has recommendedElements, if so, add these messages to the recommendationMessagesToDisplay
                if (conversation?.recommendedElements?.length) {
                    // this is the case when the conversation is in completed state and the new UI is enabled
                    recommendationMessagesToDisplay.push(
                        ...conversation.recommendedElements.filter((message: any) => message),
                    );
                }
                // if there are 2 recommendation messages, duplicate both messages to display 4 messages in a loop, this is to make the active message to be displayed on the left side
                if (recommendationMessagesToDisplay.length === 2) {
                    recommendationMessagesToDisplay.push(...recommendationMessagesToDisplay);
                }
                // check if next message is a feedback message and this feedback message is the last message
                const shouldScrollToSlider =
                    messages[nextIndex]?.type === MessageTypeEnum.feedback && nextIndex === messages.length - 1;
                return (
                    <SuggestionsSlider
                        messages={recommendationMessagesToDisplay}
                        startIndex={index}
                        shouldScrollToSlider={shouldScrollToSlider}
                    />
                );
            }
            return AssistantMessage(messages, item, index);
        };

        return (
            <>
                {messages.length && (messageLoading || consumerMessageLoading) ? (
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                        <Spinner animation="border" className={classes.spinnerLoader} />{' '}
                    </div>
                ) : null}
                {messages.map((item, index) => {
                    if (
                        item?.visible === MessageVisibleEnum.visible ||
                        (!ENABLED_SHOW_MORE_STYLES &&
                            (item?.type === MessageTypeEnum.recommendation || item?.type === MessageTypeEnum.feedback))
                    ) {
                        return (
                            <Fragment key={item?.taffiId || item?.content}>
                                <ChatDate messages={messages} index={index} />
                                {item?.role === MessageRoleEnum.user
                                    ? UserMessage(item, index)
                                    : item?.role === MessageRoleEnum.assistant
                                        ? renderRecommendationMessage(item, index)
                                        : null}
                            </Fragment>
                        );
                    } else return null;
                })}
                {isSuggestionMessageDisplay() ? chatMessageSuggestions({ isOpeningConversation }) : null}
                {conversationState?.loading ? <div>{LoaderText()}</div> : null}
                <div style={{ background: '#ffffff', paddingLeft: '10px' }}>
                    <Loader loading={pendingMessageLoading} />
                </div>
                {isStartNewConversationButtonDisplay && !isReceivedAssistantMessage ? (
                    <StartNewConversationButton
                        handleNewConversation={handleNewConversation}
                        language={conversation?.language}
                    />
                ) : null}
            </>
        );
    }, [
        isUserAuthenticated,
        conversation,
        user?.id,
        messages,
        messageLoading,
        consumerMessageLoading,
        classes.spinnerLoader,
        isSuggestionMessageDisplay,
        chatMessageSuggestions,
        conversationState?.loading,
        LoaderText,
        Loader,
        pendingMessageLoading,
        AssistantMessage,
        UserMessage,
        handleNewConversation,
        isReceivedAssistantMessage,
        isStartNewConversationButtonDisplay,
    ]);

    const isInitialMessageLoading =
        (messageLoading || consumerMessageLoading || userLoading || (utils.isAppInWidgetMode() && isWidgetOpened)) &&
        !isInitiateNewChat &&
        !messages.length;
    useSpinnerLoading('styleChatLoading', isInitialMessageLoading);
    usePersonalizedLoading();

    // hide the text input field when user is presented with "show
    // more" option. Otherwise if the user may enter a new text expecting
    // new reponse (e.g. new conversation) but currently Amira is not able to
    // process this new text provided during the ongoing conversation.
    // this is a temporary fix and will be removed when Amira is enhanced
    // to auto-detect a new conversation.
    const isDisplayTextField = useMemo(() => {
        const lastElementType = lastMessage?.elements?.[lastMessage.elements.length - 1]?.type;
        const isAuthUserOpeningConversation =
            isUserAuthenticated && conversation?.id === `_opening_conversation_${user?.id}`;
        return (
            (focusInput ||
                !lastMessage?.elements?.length ||
                !!lastMessage?.elements?.find((e) => e?.type !== StyleMessageElementTypeEnum.option_message) ||
                isSuggestionMessageDisplay()) &&
            isContinueAsGuest &&
            !lastMessage?.required &&
            user.gender &&
            !isStylistView &&
            lastElementType !== StyleMessageElementTypeEnum.show_more_suggestions &&
            (isAuthUserOpeningConversation || conversation?.status !== StyleConversationStatusEnum.done) &&
            !isDisplayArchivedThread
        );
    }, [
        isContinueAsGuest,
        lastMessage,
        user.gender,
        isStylistView,
        focusInput,
        isSuggestionMessageDisplay,
        conversation?.status,
        isDisplayArchivedThread,
        conversation?.id,
        isUserAuthenticated,
        user?.id,
    ]);

    const [isCompleteQuizPopupDisplayed, setIsCompleteQuizPopupDisplayed] = useState(true);
    const [isPopupFadingOut, setIsPopupFadingOut] = useState(false);

    const [getPendingQuizzes] = useLazyQuery(GET_PENDING_QUIZZES_RESPONSE, {
        onError() {
            console.log('pendingQuiz error');
        },
    });

    const isFirstMessage = useMemo(() => {
        return !!(messages.length === 1 && messages.find((msg) => msg?.id?.includes(OPENING_MESSAGE_ID)));
    }, [messages]);

    useEffect(() => {
        const showCompleteQuizPopup = async () => {
            const displayPopupWithAnalytics = () => {
                const isDisplayed = !!JSON.parse(
                    localStorage.getItem(SESSION_STORAGE_KEY.TAFFI_AMIRA_STYLE_QUIZ_POPUP_DISPLAYED)!,
                );
                setIsCompleteQuizPopupDisplayed(isDisplayed);
                if (
                    !isDisplayed &&
                    messages?.length &&
                    !isFirstMessage &&
                    !showAuthPopup &&
                    !isUnlockExpProcessing &&
                    user?.userType === UserType.Customer
                )
                    handleAnalytics(TRACK_EVENT.STYLE_CHAT_QUIZ_POPUP_BUTTON_DISPLAYED);
            };
            if (isUserAuthenticated) {
                const quizStatus = await getPendingQuizzes();
                const pendingQuizzes = quizStatus?.data?.getPendingQuizzes?.quizConfigs?.filter(
                    (quiz) => quiz?.status !== UserQuizStatus.done,
                );
                if (pendingQuizzes?.length) displayPopupWithAnalytics();
            } else displayPopupWithAnalytics();
        };
        showCompleteQuizPopup();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserAuthenticated, isFirstMessage, showAuthPopup, isUnlockExpProcessing]);

    const handleCloseQuizPopup = () => {
        setIsPopupFadingOut(true);
        setTimeout(() => {
            setIsCompleteQuizPopupDisplayed(true);
            localStorage.setItem(SESSION_STORAGE_KEY.TAFFI_AMIRA_STYLE_QUIZ_POPUP_DISPLAYED, JSON.stringify(true));
        }, 300);
        handleAnalytics(TRACK_EVENT.STYLE_CHAT_QUIZ_POPUP_BUTTON_CLOSED);
    };

    const handleRedirectToStyleQuiz = (source: StyleQuizRedirectionSource) => {
        if (isUserAuthenticated) {
            history.push(PATH.MY_STYLE_PREFERENCES);
        } else {
            history.push(PATH.SIGNUP_CUSTOMER);
        }
        localStorage.setItem(SESSION_STORAGE_KEY.TAFFI_AMIRA_STYLE_QUIZ_POPUP_DISPLAYED, JSON.stringify(true));
        handleAnalytics(
            source === StyleQuizRedirectionSource.COMPLETE_QUIZ_POPUP_BUTTON
                ? TRACK_EVENT.STYLE_CHAT_QUIZ_POPUP_BUTTON_CLICKED
                : TRACK_EVENT.STYLE_CHAT_QUIZ_HANGER_BUTTON_CLICKED,
        );
    };

    const handleListOptionClick = (value: any) => {
        if (value.id === conversation?.id) return;
        clearChatWindow();
        dispatch(
            updateCurrentConversationId({
                value: value.id,
            }),
        );
        getSingleConversationFn({
            variables: {
                input: {
                    id: value?.id,
                },
            },
        });
    };

    if (!user || suggestedQuestionsLoading) {
        return <LoadingDataSpinner />;
    }
    return (
        <>
            <CustomLayout
                title=""
                showHeader={false}
                containerStyle={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <ModelImageProvider>
                    <ChatHeader
                        isStylistView={isStylistView}
                        setIsOpen={setIsOpen}
                        isOpen={isOpen}
                        handleNewConversation={handleNewConversation}
                    />
                    <div className={classes.messageWrapper} onScroll={handleScroll} ref={messageContainerRef}>
                        {!isCompleteQuizPopupDisplayed &&
                            !isFirstMessage &&
                            !showAuthPopup &&
                            !isUnlockExpProcessing &&
                            user?.userType === UserType.Customer && (
                            <div
                                className={`${classes.styleQuizPopupContainer} ${
                                    isPopupFadingOut ? styles.styleQuizPopupContainerAnimation : null
                                }`}
                            >
                                <img src={HangerWhite} alt="" height={18} width="auto" />
                                <p
                                    className={classes.styleQuizPopupText}
                                    onClick={() =>
                                        handleRedirectToStyleQuiz(
                                            StyleQuizRedirectionSource.COMPLETE_QUIZ_POPUP_BUTTON,
                                        )
                                    }
                                >
                                    {STRINGS.COMPLETE_STYLE_QUIZ}
                                </p>
                                <div className={classes.styleQuizPopupHr}></div>
                                <img
                                    src={CloseIcon}
                                    alt=""
                                    height={10}
                                    width="auto"
                                    className={classes.styleQuizPopupClose}
                                    onClick={handleCloseQuizPopup}
                                />
                            </div>
                        )}
                        {Messages()}
                    </div>
                    {isDisplayTextField ? (
                        <AmiraFooter
                            handleTextChange={handleTextChange}
                            answerLoading={!!conversationState?.loading}
                            message={message}
                            messages={messages}
                            pendingMessages={pendingMessages}
                            setPendingMessages={setPendingMessages}
                            sendMessage={sendMessage}
                            storeSupportedLanguages={storeSupportedLanguages}
                            conversationLanguage={conversation?.language}
                            focusInput={focusInput}
                            setFocusInput={setFocusInput}
                            isCollectingFeedback={isCollectingFeedbackReason}
                            isSuggestionMessageDisplay={isSuggestionMessageDisplay}
                            isUploadingImage={isUploadingImage}
                            onImageSelection={handleImageSelection}
                            isOpenningConverastion={!!conversation?.id?.includes('_opening_conversation_')}
                        />
                    ) : null}
                    {showStylePreview && (
                        <WidgetPopup
                            titlePopup={''}
                            widgetProps={{
                                selectedElement,
                            }}
                            widgetCode={WidgetCode.PreviewImage}
                            onClose={() => setShowStylePreview(false)}
                            pageCode={constant.PAGE_CODE.CHAT}
                            hideHeader
                        />
                    )}
                    {showCreateProfile
                        ? createPortal(
                            <WidgetPopup
                                titlePopup={''}
                                widgetProps={{
                                    handleClose: (isNavigated, navigationAction) =>
                                        closeCreateProfilePrompt(isNavigated, navigationAction),
                                    createProfilePromptTitle,
                                }}
                                widgetCode={WidgetCode.CreateProfile}
                                onClose={() => closeCreateProfilePrompt(false, '')}
                                pageCode={constant.PAGE_CODE.CHAT}
                                isFullScreen
                                hideHeader
                            />,
                            overBottomBar,
                        )
                        : null}

                    <ModalFull open={open} handleClose={handleClose} title={item} modal_code={code} />
                    <FloatingDownArrow
                        isDisplay={displayFloatingButton}
                        scrollToLatestMessage={scrollToLatestMessage}
                        isStylistView={isStylistView}
                    />
                    <StyleImageSlider
                        item={showDynamicItemDetail}
                        user={user}
                        setShowDynamicItemDetail={setShowDynamicItemDetail}
                    />
                </ModelImageProvider>
            </CustomLayout>
            <div
                className={classes.overlay}
                style={{
                    display: `${isOpen ? 'block' : 'none'}`,
                    height: `100vh`,
                }}
                onClick={() => setIsOpen(false)}
            />
            <div
                className={classes.sideBar}
                style={{
                    height: `${height}px`,
                    display: `${isOpen ? 'block' : 'none'}`,
                }}
            >
                <ChatSidebar
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    handleListOptionClick={handleListOptionClick}
                    handleRedirectToStyleQuiz={handleRedirectToStyleQuiz}
                    handleNewConversation={handleNewConversation}
                    clearChatWindow={clearChatWindow}
                    handleFooterClick={handleClickOpen}
                />
            </div>
        </>
    );
}
